<template>
    <div>
        <section class="flex flex-col w-full mb-5">
            <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
                Events Viewer
            </h1>
        </section>

        <section class="w-3/4 table mx-auto rounded border shadow-lg">

            <section class="th tr">
                <div class="td">
                    Date/Time
                </div>
                <div class="td">
                    Event Type
                </div>
                <div class="td">
                    Description
                </div>
                <div class="td">
                    IP Address
                </div>
            </section>

            <div class="row"
                 v-for="access in usersAccess"
            >
                <div class="tr">
                    <div class="td">
                        {{ access.created_at | human}}
                    </div>
                    <div class="td">
                        {{ access.log_name }}
                    </div>
                    <div class="td">
                        {{ access.description }}
                    </div>
                    <div class="td">
                        {{ access.properties.ip_address }}
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data() {
            return {
                usersAccess: {}
            }
        },

        created() {
            axios.get('/admin/logger/users-access')
                .then(({data}) => {
                    this.usersAccess = data;
                })
        },

        filters: {
            human: (value) => {
                moment.locale('it');
                if (value != null) {
                    return moment(value).format('LLL');
                }
            }
        }
    }
</script>

<style scoped>

</style>